import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const StyleSearchLoading = styled.p`
    font-size: 18px;
    font-weight: 500;
    color: ${p => p.theme.textColor};
    margin: 80px auto 0 auto;
    text-align: center;

    ${cssMediaQueryBreakpoints.medium} {
        font-size: 15px;
        margin: 40px auto 0 auto;
    }
`
